import l10n from '../../lib/reactPPl10nHelper';

const prompt = {
  smc: l10n.getContent('smarthelp/prompt.logout.smc'),
  nonSmc: l10n.getContent('smarthelp/prompt.logout.noSmc'),
  second: l10n.getContent('smarthelp/prompt.second'),
  first: l10n.getContent('smarthelp/prompt.login.first'),
  logoutButton: l10n.getContent('smarthelp/prompt.logout.button'),
  loginButton: l10n.getContent('smarthelp/prompt.login.button'),
  emailButton: l10n.getContent('smarthelp/prompt.email.button'),
};

export default prompt;
